import { hidePreloader, showPreloader } from "../preloader";
import ajax from "../ajax";
import { showModalFromHtml } from "../modal";
import { updateCartFromHTML } from "../cart";
export default function handleAddToCartButtonClick(id, cnt = 1) {
    showPreloader();
    ajax('/api/cart/add', { id, cnt }, { dataType: 'json' })
        .then(response => response.json())
        .then(data => {
        hidePreloader();
        updateCartFromHTML(data.basket_block);
        showModalFromHtml(data.html);
        global.fbq('track', 'AddToCart', {
            content_ids: [id],
            content_type: 'product',
            contents: [{ id: id, quantity: cnt }]
        });
    });
}
